<nav class="topbar" role="banner" aria-label="Topbar">
  <div class="topbar-inner">
    <a class="logo" [routerLink]="['/']" (click)="onLogoClick(); $event.preventDefault()" title="Inicio"
      aria-label="Ir al inicio" role="link"></a>

    <div class="sections" aria-hidden="false">
      <button class="btn-new-work-order" (click)="navigateToNewWorkOrder()" [title]="'topbar.newWorkOrder' | translate"
        [attr.aria-label]="'topbar.newWorkOrder' | translate" *appHasRole="['centeradmin','groupadmin','centeruser']">
        <img src="assets/icons/plus-white.svg" class="btn-icon">
        <span class="btn-text">{{ 'topbar.newWorkOrder' | translate }}</span>
      </button>

      <button class="btn-kanban" (click)="navigateToKanban()" [title]="'topbar.kanban' | translate"
        [attr.aria-label]="'topbar.kanban' | translate" *appHasRole="['centeradmin','groupadmin','centeruser']">
        <img src="assets/icons/view-grid-white.svg" class="btn-icon">
        <span class="btn-text">{{ 'topbar.kanban' | translate }}</span>
      </button>


    </div>

    <div class="topbar-actions" role="region" aria-label="Acciones del usuario">
      <app-notification-bell *appHasRole="['centeradmin','groupadmin','centeruser']"></app-notification-bell>

      <div class="profile-card" (click)="toggleDropdown()" [ngClass]="{ 'active': isDropdownOpen }">
        <img #userAvatarImg class="user-avatar-img" [src]="userImg" alt="Avatar de usuario"
          (error)="onUserImageError($event)" decoding="async" width="34" height="34" />
        <div class="profile-info">
          <span class="profile-name">{{ userName }}</span>
          <span class="profile-email">{{ userEmail }}</span>
        </div>
        <button class="button-arrow" [ngClass]="{ 'rotated': isRotated }" [title]="'topbar.openUserMenu' | translate"
          [attr.aria-label]="'topbar.openUserMenu' | translate" aria-haspopup="true"
          [attr.aria-expanded]="isDropdownOpen" aria-controls="user-menu">
          <img src="assets/icons/chevron-header.svg" class="chevron-icon" alt="Menu">
        </button>
      </div>
    </div>
  </div>

  <div id="user-menu" class="dropdown" [ngClass]="{ 'show': isDropdownOpen }" role="menu"
    [attr.aria-hidden]="!isDropdownOpen">

    <a class="dropdown-item" routerLink="/my-account" role="menuitem" (click)="closeDropdown()">
      <img src="assets/icons/nav-my-account.svg" class="item-icon" alt="My Account">
      <span class="item-text">{{ 'my_profile' | translate }}</span>
    </a>

    <div class="dropdown-divider"></div>

    <div class="dropdown-section" *appHasRole="['centeradmin','groupadmin','centeruser']">
      <button class="dropdown-item has-submenu" (click)="toggleWorkshopSettings($event)"
        [ngClass]="{ 'expanded': isWorkshopSettingsOpen }">
        <img src="assets/icons/nav-report-management.svg" class="item-icon" alt="Workshop Settings">
        <span class="item-text">{{ 'topbar.workshopSettings' | translate }}</span>
        <img src="assets/icons/chevron-left-dark.svg" class="item-chevron" alt="Chevron">
      </button>
      <div class="submenu level-1" [ngClass]="{ 'show': isWorkshopSettingsOpen }">
        <a class="submenu-item" routerLink="/my-workshop/schedule" role="menuitem" (click)="closeDropdown()">
          <img src="assets/icons/nav-timetable.svg" class="submenu-icon" alt="Timetable">
          <span class="submenu-text">{{ 'topbar.schedules' | translate }}</span>
        </a>
        <a class="submenu-item" routerLink="/my-workshop/holidays" role="menuitem" (click)="closeDropdown()">
          <img src="assets/icons/nav-holidays.svg" class="submenu-icon" alt="Holidays">
          <span class="submenu-text">{{ 'topbar.holidays' | translate }}</span>
        </a>
        <a class="submenu-item" routerLink="/my-workshop/job-positions" role="menuitem" (click)="closeDropdown()">
          <img src="assets/icons/nav-job-positions.svg" class="submenu-icon" alt="Job Positions">
          <span class="submenu-text">{{ 'topbar.physicalPositions' | translate }}</span>
        </a>
        <a class="submenu-item" routerLink="/my-workshop/users" role="menuitem" (click)="closeDropdown()">
          <img src="assets/icons/nav-users.svg" class="submenu-icon" alt="Users">
          <span class="submenu-text">{{ 'topbar.users' | translate }}</span>
        </a>
        <div class="submenu-section">
          <button class="submenu-item has-children" (click)="toggleWarehouses($event)"
            [ngClass]="{ 'expanded': isWarehousesOpen }">
            <img src="assets/icons/nav-stores.svg" class="submenu-icon" alt="Warehouses">
            <span class="submenu-text">{{ 'topbar.warehouses' | translate }}</span>
            <img src="assets/icons/chevron-left-dark.svg" class="submenu-chevron" alt="Chevron">
          </button>
          <div class="submenu level-2" [ngClass]="{ 'show': isWarehousesOpen }">
            <a class="submenu-item level-3" routerLink="/storage" role="menuitem" (click)="closeDropdown()">
              <img src="assets/icons/nav-list.svg" class="submenu-icon-sm" alt="All Warehouses">
              <span class="submenu-text">{{ 'topbar.allWarehouses' | translate }}</span>
            </a>
            <a class="submenu-item level-3" (click)="navigateToAddWarehouse()" role="menuitem">
              <img src="assets/icons/add.svg" class="submenu-icon-sm" alt="Add Warehouse">
              <span class="submenu-text">{{ 'topbar.addWarehouse' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-divider"></div>

    <div class="dropdown-section" *appHasRole="['centeradmin','groupadmin','centeruser']">
      <button class="dropdown-item has-submenu" (click)="toggleGeneralSettings($event)"
        [ngClass]="{ 'expanded': isGeneralSettingsOpen }">
        <img src="assets/icons/nav-settings.svg" class="item-icon" alt="General Settings">
        <span class="item-text">{{ 'topbar.generalSettings' | translate }}</span>
        <img src="assets/icons/chevron-left-dark.svg" class="item-chevron" alt="Chevron">
      </button>
      <div class="submenu level-1" [ngClass]="{ 'show': isGeneralSettingsOpen }">
        <a class="submenu-item" routerLink="/widget" role="menuitem" (click)="closeDropdown()">
          <img src="assets/icons/nav-widget.svg" class="submenu-icon" alt="Widget">
          <span class="submenu-text">{{ 'topbar.widget' | translate }}</span>
        </a>
        <a class="submenu-item" *ngIf="showTapToPay" routerLink="/test-tap-to-pay" role="menuitem"
          (click)="closeDropdown()">
          <img src="assets/icons/nav-tap-to-pay.svg" class="submenu-icon" alt="Tap To Pay">
          <span class="submenu-text">{{ 'topbar.tapToPay' | translate }}</span>
          <span class="badge-beta">{{ 'topbar.beta' | translate }}</span>
        </a>
      </div>
    </div>

    <a class="dropdown-item" routerLink="/center-management" *appHasRole="['superadmin']" role="menuitem"
      (click)="closeDropdown()">
      <img src="assets/icons/icon-19.svg" class="item-icon" alt="Center Management">
      <span class="item-text">{{ 'center_management' | translate }}</span>
    </a>

    <div class="dropdown-divider"></div>

    <a class="dropdown-item logout" [routerLink]="logoutPath" role="menuitem" (click)="closeDropdown()">
      <img src="assets/icons/logout.svg" class="item-icon" alt="Logout">
      <span class="item-text">{{ 'logout' | translate }}</span>
    </a>
  </div>
</nav>
